import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import React from "react";
import Icon from "./Icon";
import mfdLogo from "./mfdLogo.png";

const VTL = () => {
  return (
    <div>
      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#033F8B", color: "#fff" }}
          contentArrowStyle={{ borderRight: "7px solid  #033F8B" }}
          date="2023-May - October"
          iconStyle={{ background: "#fff", color: "#fff" }}
          icon={
            <Icon url="https://cdn.pau.edu.tr/BIYS/siteler/isletme/tinyMCE/icons/pauLogo.png" />
          }
        >
          <h3 className="vertical-timeline-element-title">
            Mobile App. Developer
          </h3>
          <h4 className="vertical-timeline-element-subtitle">Denizli,Turkey</h4>
          <p>
            Mobile App Developer at{" "}
            <a href="https://www.pau.edu.tr/">PAU IT Departmant</a> I am working
            on mobile app development with Flutter. I am also working on the
            UI/UX of the app with Figma.
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "#033F8B", color: "#fff" }}
            contentArrowStyle={{ borderRight: "7px solid  #033F8B" }}
            date="2023-September - November"
            iconStyle={{ background: "#fff", color: "#fff", width: "50px", height: "50px", borderRadius: "50%" }}
            icon={
              <Icon url={mfdLogo}  />
            }
          >
            <h3 className="vertical-timeline-element-title">
              Junior Backend Developer
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Denizli,Turkey</h4>
            <p>
            I am involved in the development of a product with the MF Digital Media team, where I work on backend development using Java, Spring Framework, and Spring Boot. Additionally, I play a role in the frontend domain using React.
            </p>
          </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
};

export default VTL;
